var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 74 74"
    },
    viewBox: "0 0 74 74",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:currentColor;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.8,3.5H8.2c-4,0-7.2,3.2-7.2,7.2v50.5c0,4,3.2,7.2,7.2,7.2h1.2v0c0,1.1,0.9,2,2,2s2-0.9,2-2v0h47.2v0   c0,1.1,0.9,2,2,2s2-0.9,2-2v0h1.2c4,0,7.2-3.2,7.2-7.2V10.7C73,6.8,69.8,3.5,65.8,3.5z M69,61.2c0,1.8-1.4,3.2-3.2,3.2H8.2   C6.4,64.4,5,63,5,61.2V10.7C5,9,6.4,7.5,8.2,7.5h57.6c1.8,0,3.2,1.4,3.2,3.2V61.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.6,12h-47c-1.1,0-2,0.9-2,2V58c0,1.1,0.9,2,2,2h47c1.1,0,2-0.9,2-2V14C64.6,12.9,63.7,12,62.6,12z M60.6,56   h-43v-6.6h3c1.1,0,2-0.9,2-2s-0.9-2-2-2h-3V26.5h3c1.1,0,2-0.9,2-2s-0.9-2-2-2h-3V16h43V56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.9,46.1c0.4,0.4,0.9,0.6,1.4,0.6s1-0.2,1.4-0.6l3.5-3.5c2.3,1.1,5.1,1.1,7.3-0.3l3.7,3.7   c0.4,0.4,0.9,0.6,1.4,0.6c0.5,0,1-0.2,1.4-0.6c0.8-0.8,0.8-2,0-2.8l-3.7-3.7c1.3-2.3,1.4-5,0.3-7.4l3.5-3.5c0.8-0.8,0.8-2,0-2.8   c-0.8-0.8-2-0.8-2.8,0L48,29.2c-2.5-1.7-5.7-1.8-8.3-0.3l-3-3c-0.8-0.8-2-0.8-2.8,0c-0.8,0.8-0.8,2,0,2.8l3,3   c-1.5,2.6-1.4,5.8,0.3,8.3l-3.3,3.3C33.1,44,33.1,45.3,33.9,46.1z M46.3,32.9c1.5,1.5,1.5,3.9,0,5.4c0,0,0,0,0,0   c-1.5,1.5-3.9,1.5-5.4,0c-1.5-1.5-1.5-3.9,0-5.4c0,0,0,0,0,0C42.5,31.4,44.8,31.5,46.3,32.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVault);
export default __webpack_public_path__ + "static/media/icon-vault.c8dd01ab3e193cf0bd54f8ce01897355.svg";
export { ForwardRef as ReactComponent };